var isValid = function isValid(value) {
  return value !== undefined && value !== null && value !== '';
};
export default isValid;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/_util/isValid.js
// module id = 290
// module chunks = 0